module.exports = __webpack_public_path__ + "img/close.b732cd73.svg";